// Recupera o token do localStorage
export default function accessToken() {
  const _token = ( JSON.parse(localStorage.getItem("authUser")) != null ? JSON.parse(localStorage.getItem("authUser")).token : null);
  return _token;
}
